// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { apiProxy, apiUrl, getToken } from './index';
import { IPageParams, IPageResult, adaptPageParams, adaptPageResult } from './utils';

export async function fetchBranchOrgsWithPer(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.depts}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchLocations(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.locations}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchCameraByPer(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.deptCameras}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchDeptUsers(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.users}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchEvents(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.events}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function fetchIndexEvents(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.indexEvents}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function fetchVoiceEvents(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.voiceEvents}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function fetchTNEvents(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.tnEvents}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function exportEvents(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventExport}`, {
    method: 'POST',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function exportIndexEvents(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.indexEventExport}`, {
    method: 'POST',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function exportSampleTNEvents(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.tnSampleExport}`, {
    method: 'POST',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function uploadTNEvents(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.tnEventUpload}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'multipart/form-data;charset=UTF-8',
    },
    ...(options || {}),
  });
}

export async function batchEvents(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventBatch}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function batchIndexEvents(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.indexEventBatch}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function updateEventDetail(id = '', options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventDetail(id)}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function fetchEventDetail(id = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventDetail(id)}`, {
    method: 'GET',
  });
}

export async function updateIndexEventDetail(id = '', options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.indexEventDetail(id)}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function fetchIndexEventDetail(id = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.indexEventDetail(id)}`, {
    method: 'GET',
  });
}

export async function updateVoiceEventDetail(id = '', options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.voiceEventDetail(id)}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function fetchVoiceEventDetail(id = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.voiceEventDetail(id)}`, {
    method: 'GET',
  });
}

export async function updateTNEventDetail(
  id: string | number = '',
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.tnEventDetail(id)}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function cancelTNEvent(id: string | number = '', options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.tnEventCancel(id)}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function handleTNEvent(id: string | number = '', options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.tnEventHandle(id)}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function fetchTNEventDetail(id = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.tnEventDetail(id)}`, {
    method: 'GET',
  });
}

export async function fetchEventTypesById(id = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventTypesById(id)}`, {
    method: 'GET',
  });
}

export async function fetchEventDownloadUrl(id = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventDownloadUrl(id)}`, {
    method: 'GET',
  });
}

export async function downloadEventVideo(url = '', options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${url}`, {
    method: 'GET',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function fetchOrgPing(id = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.orgPing(id)}`, {
    method: 'GET',
  });
}

export async function fetchPlaybackUrl(
  id = '',
  options?: {
    eventId?: string | number;
    params?: { [key: string]: any };
    [key: string]: any;
  },
) {
  const { eventId, params, ...rest } = options || {};
  return request<Record<string, any>>(`${apiProxy}${apiUrl.playbackUrl(id)}`, {
    method: 'GET',
    params: {
      ...params,
      ...(eventId !== undefined && eventId !== null && eventId !== '' ? { eventId } : {}),
    },
    ...rest,
  });
}

export async function fetchEventVideo(id = '', options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventVideo(id)}`, {
    method: 'GET',
    ...options,
  });
}
